import { API } from "../constants/api";
import {
  axiosPostWithToken,
  axiosGetWithToken,
  axiosPut,
} from "../services/apiServices";
import { ERROR_ALERT, SUCCESS_ALERT } from "./commonAction";
import { getDateFilter } from "@flexibees/core";

export const FROM_CRM = "FROM_CRM";
export const CRM_LOADING = "CRM_LOADING";
export const CRM_LOADING_ZOHO = "CRM_LOADING_ZOHO";
export const SET_CRM_ITEMS_PER_PAGE = "SET_CRM_ITEMS_PER_PAGE";
export const CHANGE_CURRENT_CRM_PAGE = "CHANGE_CURRENT_CRM_PAGE";
export const SEARCH_CRM = "SEARCH_CRM";
export const FILTER_CRM_FUNCTIONS = "FILTER_CRM_FUNCTIONS";
export const FILTER_CRM_ROLES = "FILTER_CRM_ROLES";
export const PULL_DATA_FROM_CRM = "PULL_DATA_FROM_CRM";
export const FILTER_CRM_STATUS = "FILTER_CRM_STATUS";
export const FILTER_CRM_DATE = "FILTER_CRM_DATE";
export const CRM_SEND_TO_PROFILE = "CRM_SEND_TO_PROFILE";

export const fromCrm = () => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    const pagesize = getstate().crm.fromCRMResultsPerPage;
    const page = getstate().crm.fromCRMCurrentPage;
    const seachText = getstate().crm.fromCrmSearchText;
    const functions = getstate().crm.fromCrmAppliedFunctionFilter;
    const roles = getstate().crm.fromCrmAppliedRolesFilter;
    const status = getstate().crm.fromCrmAppliedStatusFilter;
    const date = getDateFilter(getstate().crm.fromCrmAppliedDateFilter[0]);
    const body = {
      search_term: seachText,
      filter_data: {
        functions: functions,
        roles: roles,
        status: status,
        proposed_date: date,
      },
    };

    axiosPostWithToken(
      `${API.FROM_CRM}/${pagesize}/${page}/`,
      body,
      token
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: FROM_CRM,
          payload: res.data.data,
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Unable to fetch data from Zoho.",
        });
      }
    });
  };
};

export const fetchZohoData = (refreshCrm) => {
  return async (dispatch, getstate) => {
    dispatch({
      type: CRM_LOADING_ZOHO,
    });
    const token = getstate().auth.token;
    axiosGetWithToken(`${API.PULL_FROM_CRM}`, token)
    .then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: PULL_DATA_FROM_CRM,
          payload: res.data.data,
        });
        dispatch({
          type: SUCCESS_ALERT,
          payload:
            res.data.data.message || "Successfully pulled new data from CRM.",
        });
        refreshCrm();
      } else {
        dispatch({
          type: CRM_LOADING_ZOHO,
        });
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Unable to fetch data from Zoho. Please try again later.",
        });
      }
    })
    .catch((err) => {
       dispatch({
          type: PULL_DATA_FROM_CRM,
          payload: '',
        });
        dispatch({
          type: ERROR_ALERT,
          payload: "Something went wrong. Unable to fetch data from Zoho. Please try again later."
        });
    })
  };
};

export const sendToProfileTable = (id, refreshCrm) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosPut(`${API.SEND_TO_PROFILE_TABLE}/${id}/`, {}, token).then((res) => {
      if (res.data.status_code === 200) {
        refreshCrm();
        dispatch({
          type: CRM_SEND_TO_PROFILE,
          payload: true,
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Unable to process request.",
        });
      }
    });
  };
};

export const closeSendToProfile = () => {
  return async (dispatch) => {
    dispatch({
      type: CRM_SEND_TO_PROFILE,
      payload: false,
    });
  };
};

export const setItemsPerPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: CRM_LOADING,
    });
    dispatch({
      type: SET_CRM_ITEMS_PER_PAGE,
      payload: value,
    });
  };
};

export const changeCurrentPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: CRM_LOADING,
    });
    dispatch({
      type: CHANGE_CURRENT_CRM_PAGE,
      payload: value,
    });
  };
};

export const search = (value) => {
  return async (dispatch) => {
    dispatch({
      type: CRM_LOADING,
    });
    dispatch({
      type: SEARCH_CRM,
      payload: value,
    });
  };
};

export const filterFunctions = (functions) => {
  return async (dispatch) => {
    dispatch({
      type: CRM_LOADING,
    });
    dispatch({
      type: FILTER_CRM_FUNCTIONS,
      payload: functions,
    });
  };
};

export const filterRoles = (roles) => {
  return async (dispatch) => {
    dispatch({
      type: CRM_LOADING,
    });
    dispatch({
      type: FILTER_CRM_ROLES,
      payload: roles,
    });
  };
};

export const filterStatus = (status) => {
  return async (dispatch) => {
    dispatch({
      type: CRM_LOADING,
    });
    dispatch({
      type: FILTER_CRM_STATUS,
      payload: status,
    });
  };
};

export const filterRequestDate = (date) => {
  return async (dispatch) => {
    dispatch({
      type: CRM_LOADING,
    });
    dispatch({
      type: FILTER_CRM_DATE,
      payload: date,
    });
  };
};
